import React, { createContext, useContext, useState, useEffect } from 'react';

const ContractStatusContext = createContext();

export const useContractStatus = () => useContext(ContractStatusContext);

export const ContractStatusProvider = ({ children }) => {
  const [statuses, setStatuses] = useState({});

  useEffect(() => {
    const stored = localStorage.getItem('contractStatuses');
    if (stored) {
      try {
        setStatuses(JSON.parse(stored));
      } catch {
        setStatuses({});
      }
    }
  }, []);

  const updateStatus = (contractId, status) => {
    setStatuses(prev => {
      const updated = { ...prev, [contractId]: status };
      localStorage.setItem('contractStatuses', JSON.stringify(updated));
      return updated;
    });
  };

  const getStatus = (contractId) => statuses[contractId];

  return (
    <ContractStatusContext.Provider value={{ getStatus, updateStatus }}>
      {children}
    </ContractStatusContext.Provider>
  );
};
